<script lang="ts" module>
    export const route = "/";
</script>

<script lang="ts">
    import { useOrganization } from "../lib/auth.svelte.js";
    import DashboardSO from "./dashboard-so/dashboard-so.svelte";
    import DashboardV2 from "./dashboard-v2/dashboard-v2.svelte";
    import { setBreadcrumbs } from "../lib/components/breadcrumbs.svelte";
    import { resolve } from "../lib/route.svelte.js";
    import { m } from "../lib/messages.svelte.js";
    import Sidebar from "../lib/components/sidebar/sidebar.svelte";

    const organization = useOrganization();
    const useCase = $derived(organization.metadata["useCase"] === "OC" ? ("OC" as const) : ("SO" as const));

    $effect.pre(() => {
        setBreadcrumbs([{ title: m["dashboard_"](), href: resolve("/") }]);
    });
</script>

<Sidebar>
    <div class="flex h-full grow flex-col overflow-auto">
        {#if useCase === "OC"}
            <DashboardV2 />
        {:else}
            <DashboardSO />
        {/if}
    </div>
</Sidebar>
